import {createContext} from "react"
export const SessionContext = createContext({
    sessionContext: null,
    setSessionAction: () => {},
})